<template lang="pug">
  .authorization
    .authorization__title Войти
    .authorization__title--text Добро пожаловать! Войдите в свой аккаунт, чтобы оставлять заявки в лагеря
    .authorization__form.authorization__form_entry
      form(
        @submit.prevent="onSubmitMethod"
      )
        .auth-form
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.email }"
            )
              //- form-elem_error
              .form-elem__title Email
              .form-elem__body
                input.input.input_full(
                  type="email"
                  v-model="userCredentials.email"
                  placeholder="example@mail.ru"
                  @keyup="keymonitor"
                )
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.password }"
            )
              .form-elem__title Пароль
              .form-elem__body
                input.input.input_full(
                  type="password"
                  v-model="userCredentials.password"
                  @keyup="keymonitor"
                )
          .auth-form__elem.auth-form__elem_button
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_full(
                  :class="{ 'loaded-button': pending }"
                  @click="onAuth()"
                ) Войти
                .form-elem__error(
                  v-if="msgError.length > 0"
                ) {{ msgError }}
          .auth-form__elem.auth-form__elem_link(
            v-if="showResendLink"
          )
            .form-elem
              .form-elem__body
                .link(
                  @click="resendLink()"
                ) Выслать повторно
          .auth-form__elem.auth-form__elem_link
            .form-elem
              .form-elem__body
                .link(
                  @click="$emit('onChangeModalType', 'sign_up')"
                ) Зарегистрироваться
                .link(
                  @click="$emit('onChangeModalType', 'reset_password')"
                ) Забыли пароль?
</template>

<script>
import {mapActions} from "vuex";
import jsMd5 from "js-md5";

export default {
  name: "SignIn",
  props: {},
  data() {
    return {
      pending: false,
      userCredentials: {
        // nikitos@email.com
        // aA123321
        email: "",
        password: ""
      },
      userCredentialErrors: {
        email: false,
        password: false
      },
      msgError: "",
      errorMsg: {
        server: "Неверный Email или Пароль",
        email: "Неверный формат email"
      },
      errorMsgDefault: [
        "Неверный Email или Пароль.",
        "Ваш E-mail не подтвержден."
      ],
      showResendLink: false
    };
  },
  methods: {
    ...mapActions(["auth", "getUser", "resendAuthLink"]),
    resendLink() {
      this.pending = true;
      const minutes = ("0" + new Date().getMinutes()).slice(-2);
      const reverseMinutes = minutes
        .split("")
        .reverse()
        .join("");
      const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);
      this.resendAuthLink({
        data: {
          email: this.userCredentials.email
        },
        xAuthHash
      }).then(res => {
        this.pending = false;
        if (res.status === 200) {
          this.$emit("onChangeModalType", "access_msg", {
            title: "Проверьте почту",
            text: `Мы выслали ссылку на ${this.userCredentials.email}`
          });
        } else {
          this.msgError = res.data.detail;
        }
      });
    },
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    keymonitor() {
      this.userCredentialErrors = {
        email: false,
        password: false
      };
      this.msgError = "";
    },
    onAuth() {
      const errors = [];
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.userCredentials.email.length === 0 ||
        !reg.test(this.userCredentials.email)
      ) {
        errors.push("email");
        this.msgError = this.errorMsg.email;
      }
      if (this.userCredentials.password.length === 0) {
        errors.push("password");
      }
      if (errors.length > 0) {
        errors.map(el => {
          this.userCredentialErrors[el] = true;
        });
        return;
      }
      const minutes = ("0" + new Date().getMinutes()).slice(-2);
      const reverseMinutes = minutes
        .split("")
        .reverse()
        .join("");
      const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);
      this.pending = true;
      this.auth({
        userCredentials: this.userCredentials,
        xAuthHash
      }).then(res => {
        this.pending = false;
        if (res.status === 403) {
          // ошибка авторизации
          if (res.data.code !== undefined) {
            this.msgError = this.errorMsgDefault[res.data.code];
            if (res.data.code === 1) {
              this.showResendLink = true;
            }
          } else {
            this.msgError = res.data.detail;
          }
          this.userCredentialErrors.email = true;
          this.userCredentialErrors.password = true;
          return;
        }
        this.$emit("close");
        this.getUser().then(userData => {
          this.$root.$emit("onSubmitAuthModal", userData);
        });
      });
    },
    onSubmitMethod(e) {
      e.preventDefault();
    }
  },
  mounted() {}
};
</script>
